import StarRating from 'components/Shared/StarRating';
import { colors } from 'components/styles/variables';

export interface LabeledStarRatingProps {
  label: string;
  rating: number;
  color?: 'red' | 'gold';
  showRatingNumber?: boolean;
}

export default function LabeledStarRating({
  label,
  rating,
  color,
  showRatingNumber = true,
}: LabeledStarRatingProps): JSX.Element {
  return (
    <div className="rating-container">
      <div className="rating">{label}</div>
      <div className="star-number-container">
        <StarRating value={rating} isGold={color === 'gold'} />
        {showRatingNumber && (
          <div className="rating-number" data-testid={`${label}-rating`}>
            {Number(rating).toFixed(1)}
          </div>
        )}
      </div>
      <style jsx>{`
        .rating-container {
          display: flex;
        }
        .rating {
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          letter-spacing: 0.2px;
          color: ${colors.BLACK};
        }
        .star-number-container {
          display: flex;
          justify-content: flex-end;
          width: 100%;
        }
        .rating-number {
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          text-align: right;
          letter-spacing: 0.2px;
          color: ${colors.BLACK};
          display: flex;
          padding-left: 4px;
        }
      `}</style>
    </div>
  );
}
